import { render, staticRenderFns } from "./GroupStatisticTemplateList.vue?vue&type=template&id=e5550846"
import script from "./GroupStatisticTemplateList.vue?vue&type=script&lang=js"
export * from "./GroupStatisticTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports